<div class="h-100 overflow-hidden">
  <div class="row h-100 gy-3 sets-section">
    <div class="col-md-3 col-xl-2 sets-section-inner col-addendums">
      <div class="border bg-gray-200 p-3 h-100 rounded-4 d-flex flex-column overflow-y-hidden">
        <h3 class="fs-24 mb-3 text-center">Sets</h3>
        <ul class="d-flex flex-column gap-2 h-100 list-unstyled mb-0 me-n3 overflow-y-auto pe-3">
          @for (set of templateVariables(); track $index) {
            <li
              class="border py-2 px-3 rounded-4 {{
                set.id === selectedVariable()?.id ? 'bg-primary text-white' : 'bg-white'
              }}"
              role="button"
              (click)="selectedVariable.set(set)"
            >
              <div class="d-flex align-items-center gap-2">
                <span>{{ set.firstLabel }}</span>
                <!-- <span class="badge bg-primary ms-auto fw-400">10</span> -->
              </div>
            </li>
          }
          <!-- <li class="border py-2 px-3 rounded-4 bg-white" role="button">
            <div class="d-flex align-items-center gap-2">
              <span>Default</span><span class="badge bg-primary ms-auto fw-400">10</span>
            </div>
          </li>
          <li class="border py-2 px-3 rounded-4 bg-white" role="button">
            <div class="d-flex align-items-center gap-2">
              <span>Default</span><span class="badge bg-primary ms-auto fw-400">10</span>
            </div>
          </li> -->
        </ul>
      </div>
    </div>
    <div class="col-md h-100">
      <div class="border h-100 rounded-4">
        <div class="d-flex flex-column h-100">
          <div class="d-flex flex-column pt-3 px-3">
            <div>
              <h2 class="mb-0">{{ this.selectedVariable()?.firstLabel }}</h2>
              <span>{{ visibleVariables()?.length }} Variables</span>
            </div>
            <div>
              <input type="text" class="form-control" placeholder="Search variables" [(ngModel)]="searchTerm" />
            </div>
          </div>
          <div class="flex-fill overflow-x-hidden overflow-y-auto p-3">
            <div class="row h-100 g-2 fs-14">
              @for (set of visibleVariables(); track $index) {
                <div class="col-lg-3 col-md-4 col-sm-6" title="{{ set }}">
                  <div class="border p-3 rounded-3">
                    <span class="d-block text-truncate">{{ set }}</span>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
